import TheGrid from '@/views/families/grid'
import ThePagedGrid from '@/views/families/paginated'
import Edit from '@/views/families/edit'
import TheView from '@/views/families/view'
import Importer from '@/views/families/import'

export default {
  path: '/families',
  redirect: '/families/index',
  name: 'families',
  meta: {
    auth: {
      redirect: {
        name: 'families.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Famílias'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'families.index',
    component: ThePagedGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'paginated',
    name: 'families.paginated',
    component: ThePagedGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'import',
    name: 'families.import',
    component: Importer,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'create',
    name: 'families.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'families.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'families.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
